module.exports = __webpack_public_path__ + "static/media/i_search_cancel.7f13bd6c.png";